import React, { Component } from 'react'
import OgaTree from "../../OgaTree/OgaTree";
import * as d3 from "d3-3";
import Loader from "../../elements/loader/Loader";

import API_URL from "utils/HttpClient/apiRest"

import { Button, Col, Row } from "react-bootstrap";

import { connect } from 'react-redux';

import {
    negotiateSaleOrder,
    updateSpotTreeSelection,
    saveSaleOrder
} from 'reducers/saleorder/saleorderActions';
import { showWarningMessage } from 'reducers/application/applicationActions';

class SpotTreeSelectionStep extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            selectedSearch: null,
            treeData: null
        }
    }

    onSelectionChange = (node) => {
        this.props.updateSpotTreeSelection(node.id);
    }

    componentWillMount() {
        d3.json(API_URL + 'oga/saleorder/tree?isSale=true')
            .header("authorization", localStorage.getItem('access_token'))
            .post((error, data) => {
                if (error) {
                    this.setState({ loaded: true, });
                    throw error;
                }
                this.onDataReceived(data);
            });

        /**
         * Test en local
         */
        // setTimeout(() => {
        //     this.onDataReceived(customData);
        // }, 1000);

    }

    onDataReceived(data) {
        this.setState({
            loaded: true,
            treeData: data,
            currentSelection: null
        })
    }

    isValidated() {

        if (this.props.spotNodeSelected == null) {
            this.props.showWarningMessage("Por favor seleccione uno de los espacios vacios en el árbol");
            return;
        }

        let promise = new Promise((resolve, reject) => {
            this.setState({ loaded: false });
            this.saveSaleOrder(resolve, reject);
        });

        promise.then(() => {
            this.setState({ loaded: true });
            this.props.jumpToStep(3);
        }, () => {
            this.setState({ loaded: true });
        })
    }

    buildSaleOrderDto() {
        return {
            customerId: this.props.customer.id,
            productId: this.props.product.id,
            paymentConditionsType: this.props.paymentCondition.value,
            yearsPayment: this.props.yearsPayment != null ? this.props.yearsPayment.value : null,
            campaignId: this.props.campaign != null ? this.props.campaign.value : null,
            initialQuota: this.props.negotiationSaleOrder != null ? this.props.negotiationSaleOrder.initialQuota : 0,
            nodeIdSelected: this.props.spotNodeSelected
        }
    }

    saveSaleOrder(resolve, reject) {
        let saleOrderDto = this.buildSaleOrderDto();
        this.props.saveSaleOrder(saleOrderDto, resolve, reject);
    }

    render() {
        let loaded = this.state.loaded;
        let loaderClass = loaded ? "hide" : "show";
        let treeClass = loaded ? "show" : "hide";
        let data = this.state.treeData;
        return (
            <Col className="wizard-step">
                <Row className="justify-content-between wizard-buttons">
                    <Button className="bg-light-secondary"
                        disabled={!this.state.loaded}
                        onClick={() => this.props.jumpToStep(1)}>
                        Atrás
                    </Button>

                    <Button className="bg-light-secondary"
                        disabled={!this.state.loaded}
                        onClick={() => this.isValidated()}>
                        Guardar
                    </Button>
                </Row>

                <div className="oga-tree-sale w-100">
                    <div className={`container-centered ${loaderClass}`} style={{ height: "400px" }}>
                        <div className="centered">
                            <Loader show />
                        </div>
                    </div>

                    <Row className={`row ${treeClass}`}>
                        <Col md={12}>
                            <blockquote>Seleccione un nodo en la lista!</blockquote>
                        </Col>
                        <div className="localTree col-12 border no-padding" style={{ overflow: "hidden" }}>
                            {/*fullTree*/}
                            <OgaTree
                                isSale={true}
                                treeData={data}
                                onSelectionChange={this.onSelectionChange} />
                        </div>
                    </Row>
                </div>

            </Col>
        )
    }
}
const mapStateToProps = state => ({
    product: state.saleorder.product,
    customer: state.saleorder.customer,
    yearsPayment: state.saleorder.yearsPayment,
    campaign: state.saleorder.campaign,
    paymentCondition: state.saleorder.paymentCondition,
    negotiationSaleOrder: state.saleorder.negotiationSaleOrder,
    spotNodeSelected: state.saleorder.spotNodeSelected
});
export default connect(
    mapStateToProps,
    {
        negotiateSaleOrder,
        updateSpotTreeSelection,
        showWarningMessage,
        saveSaleOrder
    },
    null,
    { withRef: true }
)(SpotTreeSelectionStep);



// WEBPACK FOOTER //
// ./src/components/SalesWizard/Steps/SpotTreeSelectionStep.jsx